import {
  DescriptionContainer,
  ImageSkeleton,
  LimitsSkeleton,
  SkeletonContainer,
  TitleSkeleton,
} from './styled';

const CoverArtSkeleton = () => (
  <SkeletonContainer>
    <DescriptionContainer>
      <TitleSkeleton />
      <LimitsSkeleton />
    </DescriptionContainer>
    <ImageSkeleton />
  </SkeletonContainer>
);

export default CoverArtSkeleton;
